import { render, staticRenderFns } from "./IcoExclamationHexagon.vue?vue&type=template&id=534559e2"
import script from "./IcoExclamationHexagon.vue?vue&type=script&lang=js"
export * from "./IcoExclamationHexagon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports